var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.03 6.2C11.03 4.54315 9.67327 3.2 7.99967 3.2C6.32608 3.2 4.96937 4.54315 4.96937 6.2V6.8H3.75725V6.2C3.75725 3.8804 5.65665 2 7.99967 2C10.3427 2 12.2421 3.8804 12.2421 6.2V6.8H11.03V6.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4239 7.1C10.4239 6.76863 10.6953 6.5 11.03 6.5H12.8482C13.8523 6.5 14.6663 7.30589 14.6663 8.3V10.4C14.6663 11.3941 13.8523 12.2 12.8482 12.2H11.03C10.6953 12.2 10.4239 11.9314 10.4239 11.6V7.1ZM11.636 7.7V11H12.8482C13.1829 11 13.4542 10.7314 13.4542 10.4V8.3C13.4542 7.96863 13.1829 7.7 12.8482 7.7H11.636Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57543 7.1C5.57543 6.76863 5.30409 6.5 4.96937 6.5H3.15119C2.14704 6.5 1.33301 7.30589 1.33301 8.3V10.4C1.33301 11.3941 2.14704 12.2 3.15119 12.2H4.96937C5.30409 12.2 5.57543 11.9314 5.57543 11.6V7.1ZM4.36331 7.7V11H3.15119C2.81647 11 2.54513 10.7314 2.54513 10.4V8.3C2.54513 7.96863 2.81647 7.7 3.15119 7.7H4.36331Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2118 12.8C9.2118 13.4627 8.66911 14 7.99967 14C7.33024 14 6.78755 13.4627 6.78755 12.8C6.78755 12.1373 7.33024 11.6 7.99967 11.6C8.66911 11.6 9.2118 12.1373 9.2118 12.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21075 13.3688C8.87786 13.4034 9.2118 13.1314 9.2118 12.8C9.2118 12.4686 8.87827 12.2046 9.21021 12.162C9.92449 12.0703 10.5421 11.8177 11.03 11.4591L12.6115 11.6C11.8456 12.5672 10.6219 13.2222 9.21075 13.3688Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/Default.cfd209de.svg";
export { ForwardRef as ReactComponent };